module.exports = __webpack_public_path__ + "static/img/manual_ja_33.7a5b3b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_33.png
// module id = T5l3
// module chunks = 4